export default "__VITE_ASSET__948b4f50__"